import { Alert } from "../types";
import { alertDefinitions } from "../data/alerts";
import { AlertDefinitionKey } from "../data/keys";

export const generateRandomAlert = (): Alert => {
  const alertKeys = Object.keys(alertDefinitions) as AlertDefinitionKey[];

  const randomKey = alertKeys[Math.floor(Math.random() * alertKeys.length)];

  const now = Date.now();
  const randomAlert = {
    id: `alert-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    definitionId: randomKey,
    timestamp: new Date().toLocaleTimeString(),
    acknowledged: false,
    createdAt: now,
    interacted: false,
  };

  console.log("generateRandomAlert", randomAlert);

  return randomAlert;
};

// Alert service manager
let alertInterval: NodeJS.Timeout | null = null;

export const startAlertService = (addAlert: (alert: Alert) => void) => {
  if (alertInterval) return; // Already running

  alertInterval = setInterval(() => {
    addAlert(generateRandomAlert());
  }, 5000); // 30 seconds

  addAlert(generateRandomAlert());
};

export const stopAlertService = () => {
  if (alertInterval) {
    clearInterval(alertInterval);
    alertInterval = null;
  }
};
